import { Icon16Props, Icon20Props } from '@zeiss/beyond-online-react';

import { GLOBAL_ACTIONS, GLOBAL_RESOURCES } from 'src/constants';
import {
  createEvaluationInfo,
  RefinedEvaluationInfo,
} from 'src/helpers/createEvaluationInfo';

export interface NavigationItem {
  href: string;
  icon: Icon16Props['icon'] | Icon20Props['icon'];
  requires: RefinedEvaluationInfo;
  tKey: string;
}

export const allNavigationItems = [
  // Only enable once we have more than one module implemented
  // {
  //   href: '/',
  //   icon: 'Home',
  //   requires: createEvaluationInfo(
  //     GLOBAL_ACTIONS.HOME_ACCESS,
  //     GLOBAL_RESOURCES.APP,
  //   ),
  //   tKey: 'common:nav.home',
  // },
  {
    href: '/tenant-management',
    icon: 'Store',
    requires: createEvaluationInfo(
      GLOBAL_ACTIONS.TM_ACCESS,
      GLOBAL_RESOURCES.APP,
    ),
    tKey: 'common:nav.tenantManagement',
  },
  {
    href: '/invitations',
    icon: 'Mail',
    requires: createEvaluationInfo(
      GLOBAL_ACTIONS.INVITATIONS_ACCESS,
      GLOBAL_RESOURCES.APP,
    ),
    tKey: 'common:nav.invitations',
  },
] satisfies NavigationItem[];
